module.exports = __webpack_public_path__ + "static/media/bg10.83a42421.jpeg";